module.exports = __webpack_public_path__ + "static/media/eye-closed.7dcb45ef.svg";